
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i0s3_1eda9_3",
  "header": "awsui_header_1i0s3_1eda9_13",
  "content": "awsui_content_1i0s3_1eda9_17",
  "error": "awsui_error_1i0s3_1eda9_21",
  "footer": "awsui_footer_1i0s3_1eda9_25",
  "actions-section": "awsui_actions-section_1i0s3_1eda9_29",
  "secondary-actions": "awsui_secondary-actions_1i0s3_1eda9_38",
  "actions": "awsui_actions_1i0s3_1eda9_29"
};
  